import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const StandaloneLogin = () => {
  const [email, setEmail] = useState('nuevoadmin@test.com');
  const [password, setPassword] = useState('admin123');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const navigate = useNavigate();

  const handleDirectLogin = async () => {
    console.log('🚀 DIRECT LOGIN STARTED');
    setLoading(true);
    setResult(null);

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const loginUrl = `${backendUrl}/api/auth/login`;

      console.log('🔐 Making direct login request to:', loginUrl);

      const response = await fetch(loginUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (response.ok && data.token && data.user) {

        // Store data directly in localStorage
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));

        // Navigate based on role
        if (data.user.role === 'admin' || data.user?.role === 'superadmin') {
          window.location.href = '/admin';
        } else if (data.user.role === 'gestor') {
          window.location.href = '/gestor';
        } else {
          window.location.href = '/dashboard';
        }

        setResult({ success: true, message: 'Login exitoso! Redirigiendo...' });
      } else {
        console.error('❌ Login failed:', data);
        setResult({ success: false, message: data.detail || 'Login failed' });
      }

    } catch (error) {
      console.error('❌ Login error:', error);
      setResult({ success: false, message: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">🚀 Standalone Login</h1>
        <p className="text-sm text-gray-600 mb-4">
          Direct API call without useAuth hook. Backend URL: {process.env.REACT_APP_BACKEND_URL}
        </p>

        {result && (
          <div className={`mb-4 p-4 rounded ${result.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            {result.message}
          </div>
        )}

        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border rounded-lg"
            placeholder="test@test.com"
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium mb-2">Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 border rounded-lg"
            placeholder="test123"
          />
        </div>

        <button
          onClick={handleDirectLogin}
          disabled={loading}
          className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 disabled:opacity-50 mb-4"
        >
          {loading ? 'Logging in...' : '🚀 Direct Login (No Hook)'}
        </button>

        <button
          onClick={() => navigate('/dashboard')}
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
        >
          <Target /> Test Navigation to Dashboard
        </button>

        <p className="mt-4 text-xs text-gray-500">
          This bypasses useAuth completely and stores data directly in localStorage
        </p>
      </div>
    </div>
  );
};

export default StandaloneLogin;